import { render, staticRenderFns } from "./InfoButton.vue?vue&type=template&id=62c24b1d&scoped=true&"
import script from "./InfoButton.vue?vue&type=script&lang=js&"
export * from "./InfoButton.vue?vue&type=script&lang=js&"
import style0 from "./InfoButton.vue?vue&type=style&index=0&id=62c24b1d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c24b1d",
  null
  
)

export default component.exports